import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';
import { useSimulationId } from '../../components/organisms/ProductionPlans/GanttSimulation/hooks/useSimulationId';

export const GRAPHNE_TODO_LIST_KEY = 'graphne-todo-list';

export const useGraphneTodoList = (enabled?: boolean) => {
  const api = useGraphneAPI();
  const simulationId = useSimulationId();

  return useQuery({
    queryKey: [GRAPHNE_TODO_LIST_KEY, simulationId],
    enabled,
    queryFn: () =>
      api.postGraphneTodoList({
        taskFilterDefinition: { skip: 0, take: 0, simulationId: simulationId.id ? simulationId.id : undefined },
      }),
  });
};
